module.exports = __webpack_public_path__ + "static/newbrownbearcomf-87587414804584f3156730c5a765ff45.jpeg";